<div class="titlebar">
  <h3>
    {{ "Template.SupplierDetailComponent.subHeader_supplier" | translate }}@if (supplier) {
    <span>: {{ supplier.attributes?.["NAME"] }}</span>
  }
</h3>

<div class="buttons">
  <button class="btn btn-secondary" [disabled]="loading['supplier']" (click)="reload()">
    <fa-icon icon="arrow-rotate-right"></fa-icon>
  </button>
</div>
</div>

@if (loading['supplier']) {
  <fa-icon icon="spinner" animation="spin"></fa-icon>
}

@if (supplier) {
  <div>
    <ul class="nav nav-tabs" ngbNav #tabs="ngbNav">
      <li class="nav-item" ngbNavItem>
        <a class="nav-link" ngbNavLink="#details">{{ "Template.SupplierDetailComponent.text_details" | translate }}</a>
        <ng-template ngbNavContent>
          <div class="tab-pane fade show" id="details" role="tabpanel">
            <h5 class="mb-2">{{ "Template.SupplierDetailComponent.subHeader_generalInformation" | translate }}:</h5>
            <div class="row">
              <div class="col-6 col-xs-12 px-4">
                <div class="row">
                  <div class="col-6">
                    <strong>{{ "Template.SupplierDetailComponent.text_gln" | translate }}:</strong>
                  </div>
                  <div class="col-6">
                    {{ supplier! | identification: "GLN" }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <strong>{{ "Template.SupplierDetailComponent.text_name" | translate }}:</strong>
                  </div>
                  <div class="col-6">
                    {{ supplier.attributes?.["NAME"] }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <strong>{{ "Template.SupplierDetailComponent.text_enabled" | translate }}:</strong>
                  </div>
                  <div class="col-6">
                    @if (supplier.enabled) {
                      <span>{{ "Template.SupplierDetailComponent.text_yes" | translate }}</span>
                    }
                    @if (!supplier.enabled) {
                      <strong class="text-danger">
                        {{ "Template.SupplierDetailComponent.text_no" | translate }}
                        <fa-icon icon="exclamation-triangle"></fa-icon>
                      </strong>
                    }
                  </div>
                </div>
              </div>
              <div class="col-6 col-xs-12">
                @if (supplier.enabled) {
                  <button class="btn btn-warning d-block w-100" (click)="toggleSupplier(false)">{{ "Template.SupplierDetailComponent.btn_disable" | translate }}</button>
                }
                @if (!supplier.enabled) {
                  <button class="btn btn-success d-block w-100" (click)="toggleSupplier(true)">{{ "Template.SupplierDetailComponent.btn_enable" | translate }}</button>
                }
                @if (!(supplier | partyRel: 'SUPPLIER_DATA_STREAM_RELATIONSHIP')) {
                  <button class="btn btn-info d-block w-100 mt-2" (click)="changeSupplierName()">{{ "Template.SupplierDetailComponent.btn_changeName" | translate }}</button>
                }
                @if (!(supplier | partyRel: 'SUPPLIER_DATA_STREAM_RELATIONSHIP')) {
                  <button class="btn btn-info d-block w-100 mt-2" (click)="changeSupplierGln()">{{ "Template.SupplierDetailComponent.btn_changeGln" | translate }}</button>
                }
                @if (supplier | partyRel: 'SUPPLIER_DATA_STREAM_RELATIONSHIP') {
                  <div [ngbTooltip]="'Template.SupplierDetailComponent.btn_changeNameDisabled' | translate">
                    <button class="btn btn-info d-block w-100 mt-2" disabled>{{ "Template.SupplierDetailComponent.btn_changeName" | translate }}</button>
                  </div>
                }
                @if (supplier | partyRel: 'SUPPLIER_DATA_STREAM_RELATIONSHIP') {
                  <div [ngbTooltip]="'Template.SupplierDetailComponent.btn_changeGlnDisabled' | translate">
                    <button class="btn btn-info d-block w-100 mt-2" disabled>{{ "Template.SupplierDetailComponent.btn_changeGln" | translate }}</button>
                  </div>
                }
              </div>
            </div>
            <hr />
            <!-- nested/child component -->
            @if (supplier) {
              <app-employees [isCustomer]="false" [party]="supplier"></app-employees>
            }
          </div>
        </ng-template>
      </li>
      <li class="nav-item" ngbNavItem>
        <a class="nav-link" ngbNavLink="#upload">{{ "Template.SupplierDetailComponent.text_dataManagement" | translate }}</a>
        <ng-template ngbNavContent>
          <div class="tab-pane fade show" id="upload" role="tabpanel">
            <button class="btn d-block w-100 mb-2" (click)="toggleDataUploadRel()" [class]="{ 'btn-outline-danger': (supplier | partyRel: 'SUPPLIER_DATA_UPLOAD_RELATIONSHIP'), 'btn-success': !(supplier | partyRel: 'SUPPLIER_DATA_UPLOAD_RELATIONSHIP') }" [disabled]="loading['dataUploadRel']">
              @if (supplier | partyRel: 'SUPPLIER_DATA_UPLOAD_RELATIONSHIP') {
                <span>{{ "Template.SupplierDetailComponent.btn_disableDataUpload" | translate }}</span>
              }
              @if (!(supplier | partyRel: 'SUPPLIER_DATA_UPLOAD_RELATIONSHIP')) {
                <span>{{ "Template.SupplierDetailComponent.btn_enableDataUpload" | translate }}</span>
              }
              @if (loading['dataUploadRel']) {
                <fa-icon icon="spinner" animation="spin" class="ms-2"></fa-icon>
              }
            </button>
            @if (supplier | partyRel: 'SUPPLIER_DATA_UPLOAD_RELATIONSHIP') {
              <hr />
            }
            @if (id && (supplier | partyRel: 'SUPPLIER_DATA_UPLOAD_RELATIONSHIP')) {
              <app-data-management [partyId]="id"></app-data-management>
            }
          </div>
        </ng-template>
      </li>
      @if (supplier | partyRel: 'SUPPLIER_DATA_STREAM_RELATIONSHIP') {
        <li class="nav-item" ngbNavItem>
          <a class="nav-link" ngbNavLink="#dataAccesses">{{ "Template.SupplierDetailComponent.text_dataStream" | translate }}</a>
          <ng-template ngbNavContent>
            <div class="tab-pane fade show" id="dataAccesses" role="tabpanel">
              @for (dataStream of dataStreams; track dataStream) {
                <div>
                  @if (dataStreams && dataStreams.length > 1) {
                    <h4 class="fs-5 text-primary">{{ dataStream.supplier?.attributes?.["NAME"] }}</h4>
                  }
                  <app-data-approvals [dataStreamId]="dataStream.id"></app-data-approvals>
                </div>
              }
            </div>
          </ng-template>
        </li>
      }
      @if (supplier | partyRel: 'SUPPLIER_ORDER_RELATIONSHIP') {
        <li class="nav-item" ngbNavItem>
          <a class="nav-link" ngbNavLink="#orderAccesses">{{ "Template.SupplierDetailComponent.text_connectionToZrBusiness" | translate }}</a>
          <ng-template ngbNavContent>
            <div class="tab-pane fade show" id="orderAccesses" role="tabpanel">
              @if (id) {
                <app-order-accesses [partyId]="id"></app-order-accesses>
              }
            </div>
          </ng-template>
        </li>
      }
    </ul>
    <div class="tab-content" [ngbNavOutlet]="tabs"></div>
  </div>
}
